"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RevieveVirtualTryOnPDP = void 0;
var _analyticsData = require("@ori/analytics-data");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("../../constants");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _utils = require("../../utils");
var _Loading = require("../Loading");
var _Restore = require("../Restore");
var _VirtualTryOnDialog = require("./VirtualTryOnDialog");
var _constants2 = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
const RevieveVirtualTryOnPDP = () => {
  const {
    revieveConfiguration
  } = (0, _contexts.useNovageSkincareAdvisor)();
  const {
    open: dialogOpen,
    onOpen,
    onClose
  } = (0, _presentationHooks.useDisclose)();
  const {
    close,
    continueToPdp,
    initConfig,
    onInit,
    open,
    reset,
    state
  } = (0, _hooks.useRevieve)({
    queryParam: _constants.OPEN_VIRTUAL_TRY_ON_PDP_QUERY_PARAM,
    recommendationPageEnabled: true,
    partnerId: revieveConfiguration?.virtualTryOnPdp?.partnerId,
    placement: _analyticsData.Placement.RevieveVirtualTryOnPDP,
    renderTo: document.getElementById(_constants2.VIRTUAL_TRY_ON_PDP_CONTAINER),
    configOverrides: {
      // We want to init revieve when dialog is opened so that getElementById returns the correct element
      dialogOpen
    },
    onClose,
    onOpen
  });
  const onLoad = (0, _react.useCallback)(() => {
    (0, _utils.initRevieve)(initConfig, onInit);
  }, [initConfig, onInit]);
  (0, _hooks.useRevieveScript)({
    param: _constants.OPEN_VIRTUAL_TRY_ON_PDP_QUERY_PARAM,
    onLoad
  });
  // istanbul ignore next @preserve -- Calling of onClick is tested in useOnHrefClick
  const onClick = (0, _react.useCallback)(() => {
    reset();
    open();
  }, [reset, open]);
  (0, _hooks.useOnHrefClick)({
    href: _constants.OPEN_VIRTUAL_TRY_ON_PDP_HREF_REGEXP,
    onClick
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {
      show: state === _constants.STATE_LOADING
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Restore.Restore, {
      show: state === _constants.STATE_RESTORED,
      onClose: close,
      onContinue: continueToPdp,
      onReset: reset
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualTryOnDialog.VirtualTryOnDialog, {
      open: dialogOpen,
      onClose: close
    })]
  });
};
exports.RevieveVirtualTryOnPDP = RevieveVirtualTryOnPDP;
